<template>
  <v-card id="listcard" class="ma-5" >

  <v-card-item>
    <v-card-title class="text-headline-small">Raccolta files</v-card-title>
  </v-card-item>
    <v-card-text>
      <!-- <v-card-title class="text-headline-small">
        <router-link to="/data/" style="text-decoration: none!important;"><v-icon size="x-small">mdi-arrow-left</v-icon></router-link>
      </v-card-title> -->

      <p>Sono presenti <br>
        - i media raccolti: foto, video, audio.<br>
        - altri tipi: geojson
      </p>
      <p>La raccolta conta {{ total  }} files in totale.</p>
          
    </v-card-text>
    <v-divider />

      <v-card-text>
        <files-browser purpose="media" />
      </v-card-text>

  </v-card>
</template>

<script setup>

import { ref, onMounted } from 'vue'
import { useFilesStore } from "@/store/files";
import FilesBrowser from '@/components/media/FilesBrowser.vue'

const total = ref(0)
const filesStore= useFilesStore()

onMounted(async() => {
  // console.log('MediaView mounted')
  // console.log('MediaView mounted', $store.state.media)
  total.value = await filesStore.count()
})


</script>
<style scoped>
</style>
